import React from "react";

export default function CommerceSkeleton() {
  return (
    <div className="grid gap-5 lg:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          key={index}
          className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
        >
          <div className="h-64 animate-pulse bg-slate-200 dark:bg-slate-800" />

          <div className="space-y-4 p-5">
            <div className="h-5 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-7 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

            <div className="space-y-2">
              <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-4 w-10/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
              <div className="h-4 w-8/12 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
            </div>

            <div className="flex gap-2">
              <div className="h-11 w-32 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
              <div className="h-11 w-32 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}